import { useEffect, useState } from "react";
import { _Entailment, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable, MASK_MONEY } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { _ImportBanking, _StatementMovement } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { BankAccountSelect } from "../../../erp/cellEditor/BankAccount/BankAccountSelect";
import { YearSelector } from "../../../../core/shared/inputs/YearSelector";
import { FileService } from "../../../../core/services/FileService";
import { InputDate } from "../../../theme/Input/InputDate";
import { FileInput } from "../../../theme/Component/FileInput";
import { StatementMovementCatalog } from "../StatementMovementCatalog/StatementMovementCatalog";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { InputMoney } from "../../../theme/Input/InputMoney";



export const BankingStatementMovement = () => {

    const StatementMovement = useDataBean(_StatementMovement);
    const importBanking = useDataBean(_ImportBanking);
    const single = Singleton.getInstance();
    const [form, setForm] = useState<any>({
        IDAccount: NaN,
        Year: _single.getCurrenYear(),
        MonthVigency: NaN,
        Type: null,
    })

    const fileService = new FileService();
    const [lista, setLista] = useState<any>([]);
    const [idBankingAccount, setidBankingAccount] = useState<number>(null)
    const [year, setyear] = useState<number>(null)
    const [modalconsultar, setModalconsultar] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalimp, setModalimp] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    // useEffect(() => {
    //     getLista();
    // }, [])

    const getLista = () => {

        StatementMovement.instance.BankingStatement(idBankingAccount, form.Year).then(
            (resp: any) => {
                if (resp) {
                    let tmp = resp;
                    tmp.forEach((element: any) => {
                        if (element.DataBeanProperties.MediaContext) {
                            element.DataBeanProperties.URL = ` <a href="${fileService.getUrlFile(element.DataBeanProperties.MediaContext, element.DataBeanProperties.Media)}" target='_blank'>VER DOCUMENTO</a>`

                        } else {
                            element.DataBeanProperties.URL = "Sin Documento";
                        }
                    });
                    setLista(tmp);
                } else {
                    setLista([]);
                }

            }
        )

    }
    const importBankingStatement = () => {
        importBanking.instance.importBankingStatement(StatementMovement.bean.IDBankingStatement, importBanking.bean.Media, importBanking.bean.MediaContext, null).then(
            (resp: any) => {
                console.log(resp)
                setModalimp({ ...modalimp, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const create = () => {
        StatementMovement.setBean({
            IDBankingAccount: StatementMovement.bean.IDBankingAccount
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        StatementMovement.instance.deleteBankingStatementData(StatementMovement.bean.IDBankingStatement).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )
    }
    const editaItem = () => {
        //console.log(entailment.bean);
        StatementMovement.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDBankingStatement', visible: true },
        { title: 'Fecha Inicio Corte', property: 'StartingDate', visible: true },
        { title: 'Fecha fin de Corte', property: 'EndingDate', visible: true },
        { title: 'Saldo Inicial', property: 'InitialLeft', visible: true, mask: MASK_MONEY },
        { title: 'Saldo Final', property: 'EndingLeft', visible: true, mask: MASK_MONEY },
        { title: 'Ver / Descargar Archivo del Extracto', property: 'URL', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${StatementMovement.bean.Name}`, "view": true }) } },
            { titulo: 'Consultar Movimiento de Extracto', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModalconsultar({ ...modalconsultar, "view": true }) } },
            { titulo: 'Importar Extracto Bancario', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModalimp({ ...modalimp, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Extractos Bancarios">
            <div className="row">
                <div className="col-md-6">
                    <BankAccountSelect label="Cuenta Bancaria" idSelector={idBankingAccount} onChange={(e) => { setidBankingAccount(e) }} />
                </div>
                <div className="col-md-6">
                    <YearSelector tittle="Año" value={form.Year} onChange={(e) => { setForm({ ...form, "Year": e }) }} />
                </div>
                <div className="col-md-6 mt-4">
                    <BasicButton icon="ri-search-line" eventClick={getLista} >Buscar</BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={StatementMovement.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-12">
                                <BankAccountSelect label="Cuenta Bancaria" idSelector={StatementMovement.bean.IDBankingAccount} onChange={(e) => StatementMovement.setBean({ ...StatementMovement.bean, "IDBankingAccount": e })} />
                            </div>
                            <div className="col-md-6">
                                <InputDate name="StartingDate" label="Fecha de Corte" value={StatementMovement.bean.StartingDate} setDate={(e) => StatementMovement.setBean({ ...StatementMovement.bean, "StartingDate": e })} />
                            </div>
                            <div className="col-md-6">
                                <InputDate name="EndingDate" label="Fecha de Corte" value={StatementMovement.bean.EndingDate} setDate={(e) => StatementMovement.setBean({ ...StatementMovement.bean, "EndingDate": e })} />
                            </div>
                            <div className="col-md-6">
                                <label>Saldo Inicial</label>
                                <InputMoney _value={StatementMovement.bean.InitialLeft} onChange={(e) => { StatementMovement.setBean({ ...StatementMovement.bean, "InitialLeft": e }) }} />
                                {/* <input type="text" name="InitialLeft" className="form-control" value={StatementMovement.bean.InitialLeft} onChange={StatementMovement.handleChange} /> */}
                            </div>
                            <div className="col-md-6">
                                <label>Saldo Final</label>
                                <InputMoney _value={StatementMovement.bean.EndingLeft} onChange={(e) => { StatementMovement.setBean({ ...StatementMovement.bean, "EndingLeft": e }) }} />
                                {/* <input type="text" name="EndingLeft" className="form-control" value={StatementMovement.bean.EndingLeft} onChange={StatementMovement.handleChange} /> */}

                            </div>
                            <div className="col-md-6">
                                <FileInput
                                    label='Documento Adjunto'
                                    directory='DocComercio'
                                    onCreate={({ Media, MediaContext }) => { StatementMovement.setBean({ ...StatementMovement.bean, "Media": Media, "MediaContext": MediaContext }) }}
                                />
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalimp} updateModal={setModalimp} eventModal={importBankingStatement}>
                        <div className="row">
                            <div className="col-md-12">
                                <FileInput
                                    label='Archivo de excel a importar'
                                    directory='DocComercio'
                                    onCreate={({ Media, MediaContext }) => { importBanking.setBean({ ...importBanking.bean, "Media": Media, "MediaContext": MediaContext }) }}
                                />
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalconsultar} updateModal={setModalconsultar}>
                        <div className="row">
                            <div className="col-md-12">
                                <StatementMovementCatalog idBankingStatement={StatementMovement.bean.IDBankingStatement} BankingAccountParent={idBankingAccount} />
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {StatementMovement.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}